import React, { useState } from "react";
import useBackdropClose from "../../hooks/useBackdropClose";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../config/constants";
import {
  Overlay, Modal, ModalTitle, Subtitle, Grid, Field, Label, Input,
  ErrorMsg, ActionRow, CancelButton, SubmitButton,
} from "./styles";

const todayStr = () => new Date().toISOString().slice(0, 10);

const ScheduleConsultationModal = ({ patientId, onClose, onScheduled }) => {
  const { t } = useTranslation();
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!date || !time) return;

    // El servidor guarda un DATETIME: lo construimos en hora local, sin zona,
    // para que no se desplace al serializar.
    const scheduledAt = `${date} ${time}:00`;
    if (new Date(`${date}T${time}`) <= new Date()) {
      setError(t("scheduleConsultation.errors.past"));
      return;
    }

    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/sessions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ patient_id: patientId, scheduled_at: scheduledAt }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "error");
      onScheduled(scheduledAt);
    } catch {
      setError(t("scheduleConsultation.errors.generic"));
      setLoading(false);
    }
  };

  return (
    <Overlay {...useBackdropClose(onClose)}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <ModalTitle>{t("scheduleConsultation.title")}</ModalTitle>
        <Subtitle>{t("scheduleConsultation.subtitle")}</Subtitle>

        <Grid>
          <Field>
            <Label htmlFor="sc-date">{t("scheduleConsultation.date")}</Label>
            <Input
              id="sc-date"
              type="date"
              min={todayStr()}
              value={date}
              onChange={(e) => { setDate(e.target.value); setError(""); }}
            />
          </Field>

          <Field>
            <Label htmlFor="sc-time">{t("scheduleConsultation.timeSlot")}</Label>
            <Input
              id="sc-time"
              type="time"
              value={time}
              onChange={(e) => { setTime(e.target.value); setError(""); }}
            />
          </Field>
        </Grid>

        {error && <ErrorMsg>{error}</ErrorMsg>}

        <ActionRow>
          <CancelButton onClick={onClose}>{t("scheduleConsultation.cancel")}</CancelButton>
          <SubmitButton disabled={!date || !time || loading} onClick={submit}>
            {loading ? t("scheduleConsultation.sending") : t("scheduleConsultation.send")}
          </SubmitButton>
        </ActionRow>
      </Modal>
    </Overlay>
  );
};

export default ScheduleConsultationModal;
